<template>
  <div class="TableSearch">
    <Row>
      <Column v-if="hasSearch" :xs="columns">
        <Field
          icon="search"
          :placeholder="placeholder || 'Search'"
          type="text"
          :value="table.search"
          @update:value="$emit('update:search', $event)" />
      </Column>
      <Column v-if="hasSort" :xs="columns">
        <Field
          v-if="hasSort"
          :options="sortOptions"
          type="select"
          :value="table.sortIndex"
          @update:value="$emit('update:sortIndex', $event)" />
      </Column>
      <!--
      <template v-if="queryCount">
        <Column v-for="(field, key) in table.query" :md="12 / queryCount" :key="key">
          <QueryField :field="field"/>
        </Column>
      </template>
      -->
    </Row>
  </div>
</template>

<script>
// import QueryField from './QueryField'

export default {
  props: {
    table: Object,
    placeholder: String,
  },
  computed: {
    columns() {
      return this.hasSort && this.hasSearch ? 6 : 12
    },
    hasSearch() {
      return this.table.search !== false
    },
    hasSort() {
      return this.table.sortOptions.length > 1
    },
    sortOptions() {
      return this.table
        .sortOptions
        .map(({ label, labelKey }, index) => [index, label || this.$t(labelKey)])
    },
    // queryCount() {
    //   return Object.keys(this.table.query).length + (this.filterExists ? 1 : 0)
    // },
  },
}
</script>

<style lang="scss">
.TableSearch {
  padding: 0;

  .Field {
    margin-bottom: 0;

    &.with-icon {
      border: 1px solid $border-color;

      input,
      select {
        background: transparent;
        font-size: $h6;
      }

      > .Icon {
        border-right: none;
        color: $text-color-mid;
      }
    }
  }
}
</style>

<i18n>
{
  "en": {
    "sort": {
      "old": "Oldest",
      "new": "Newest"
    }
  }
}
</i18n>
